import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import RegistrationCodeForm from '../containers/RegistrationCodeFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import {
  mixpanelEventsEnum,
  MixpanelTracker,
} from '../../../../../lib/Mixpanel';

class RegistrationCodeEditScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `RegistrationCodeEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  trackerActions = (eventMixpanel, params = {}) => {
    if (this.props.role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: this.props.partnershipName ?? 'No partnership',
        partnershipId: this.props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('registration_code_route_edit')} />
            <RegistrationCodeForm
              id={this.props.match.params.id}
              trackerActions={this.trackerActions}
            />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
    this.trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.REGISTRATION_CODES_EDIT_SCREEN
    );
  }
}

export default RegistrationCodeEditScreen;

Logger.log('silly', `RegistrationCodeEditScreen loaded.`);
